"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubmitCampaignsDto = void 0;
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const create_media_campaign_dto_1 = require("./create-media-campaign.dto");
class SubmitCampaignsDto {
    forceScreenshots;
    /** Internal immutable rotation reference; not accepted in public creation payloads. */
    creativeRotationSnapshotId;
    /** Internal worker reference; never accepted by the public creation validator. */
    adaptationSnapshotId;
    summaryId;
    mediaId;
    campaignTitle;
    skipPayment;
    creationId;
    settings;
}
exports.SubmitCampaignsDto = SubmitCampaignsDto;
__decorate([
    (0, class_validator_1.IsBoolean)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Boolean)
], SubmitCampaignsDto.prototype, "forceScreenshots", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], SubmitCampaignsDto.prototype, "creativeRotationSnapshotId", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], SubmitCampaignsDto.prototype, "adaptationSnapshotId", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    __metadata("design:type", String)
], SubmitCampaignsDto.prototype, "summaryId", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.ValidateIf)((o) => !o.mediaId),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], SubmitCampaignsDto.prototype, "mediaId", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], SubmitCampaignsDto.prototype, "campaignTitle", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Boolean)
], SubmitCampaignsDto.prototype, "skipPayment", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], SubmitCampaignsDto.prototype, "creationId", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.ValidateIf)((o) => !!o.settings && o.settings.length > 0),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Type)(() => create_media_campaign_dto_1.MediaInCampaignDisplaySettingsDto),
    __metadata("design:type", Array)
], SubmitCampaignsDto.prototype, "settings", void 0);
